
export const initialState = {
  companyName: '',
  email: '',
  phone: '',
  website: '',
  bankName: '',
  bankNumber: '',
  bankPermission: false,
}